import { f7 } from 'framework7-react';

// Fallback shown when navigator.clipboard is unavailable (insecure http context /
// permission denied) - display the value so the operator can copy it by hand. A
// plain f7.dialog.alert renders the value in F7's .dialog-text, which never
// wraps, so a long URL overflows off-screen. This dialog wraps the value
// (overflow-wrap: anywhere), makes it tap-to-select, and uses the app's filled
// primary button (orange bg / white text) for OK. Shared so every copy button
// behaves identically.
export function showCopyFallbackDialog(value: string, title: string, okLabel: string) {
  f7.dialog
    .create({
      title,
      content: `<div style="overflow-wrap:anywhere;user-select:all;padding:8px 0;text-align:left">${value}</div>`,
      buttons: [{ text: okLabel, close: true, cssClass: 'dialog-btn-primary' }],
    })
    .open();
}
